import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import api from "../lib/api";
import { TrendingUp, TrendingDown } from "lucide-react";

export default function CryptoTicker() {
  const [coins, setCoins] = useState([]);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const { data } = await api.get("/crypto/prices");
        if (mounted) setCoins(data);
      } catch (_) {}
    };
    load();
    const id = setInterval(load, 60000);
    return () => { mounted = false; clearInterval(id); };
  }, []);

  if (!coins.length) return <div className="h-10 bg-black border-y border-white/10" />;

  return (
    <div
      data-testid="crypto-ticker"
      className="bg-black border-y border-white/10 ticker-mask overflow-hidden"
    >
      <Marquee speed={45} gradient={false} pauseOnHover>
        {coins.map((c) => {
          const up = c.change_24h >= 0;
          return (
            <div
              key={c.id}
              data-testid={`ticker-${c.symbol}`}
              className="flex items-center gap-2 px-6 h-10 font-mono text-sm border-r border-white/5"
            >
              <span className="text-zinc-500">{c.symbol}</span>
              <span className="text-white">${c.price?.toLocaleString(undefined, { maximumFractionDigits: 4 })}</span>
              <span className={`flex items-center gap-1 ${up ? "text-emerald-400" : "text-red-400"}`}>
                {up ? <TrendingUp className="w-3 h-3" /> : <TrendingDown className="w-3 h-3" />}
                {c.change_24h.toFixed(2)}%
              </span>
            </div>
          );
        })}
      </Marquee>
    </div>
  );
}
